import React from 'react';
import styled, { keyframes } from 'styled-components';
import { colors } from '../../../defaultTheme';
const LogoContainer = styled.div `
  display: flex;
  align-items: center;
  position: relative;
  justify-content: center;
  height: ${({ size }) => 16 * size}px;
  width: ${({ size }) => 12.12 * size}px;
`;
const CommonBarStyles = styled.div `
  width: 28%;
  position: absolute;
  animation: 1.8s ease infinite;
  background-color: ${({ color }) => color};
`;
const LeftBarAnimation = keyframes `
  0% { height: 0 }
  20% { height: 50% }
  40% { height: 50% }
  60% { height: 50% }
  80% { height: 0; top: 50%}
  100% { height: 0; }
`;
const MiddleBarAnimation = keyframes `
  0% { height: 0 }
  20% { height: 0 }
  40% { height: 100% }
  60% { height: 100% }
  80% { height: 100% }
  100% { height: 0 }
`;
const RightBarAnimation = keyframes `
  0% { height: 0 }
  20% { height: 0 }
  40% { height: 0 }
  60% { height: 50%; top: 0 }
  80% { height: 0; top: 50%}
  100% { height: 0 }
`;
const LeftBar = styled(CommonBarStyles) `
  animation-name: ${LeftBarAnimation};
  bottom: 0;
  left: 0;
`;
const Middlebar = styled(CommonBarStyles) `
  animation-name: ${MiddleBarAnimation};
`;
const RightBar = styled(CommonBarStyles) `
  animation-name: ${RightBarAnimation};
  top: 0;
  right: 0;
`;
const SyfLoader = ({ size = 1, id = 'syf-loader', className, leftBarcolor = colors.syfYellow, middleBarcolor = colors.syfYellow, rightBarcolor = colors.syfYellow }) => {
    return (React.createElement(LogoContainer, { className: className, role: "img", "aria-label": "Content Loading", id: id, size: size },
        React.createElement(LeftBar, { color: leftBarcolor }),
        React.createElement(Middlebar, { color: middleBarcolor }),
        React.createElement(RightBar, { color: rightBarcolor })));
};
export default SyfLoader;
